import React from 'react'
import "./prrogbar.css"

function ProgressBar({ title, progress, levels }) {
    return (
        <div className="progress-bar-container1" style={{ position: "relative" }}>
            <h5 className={`${title === "Difficulty" ? "titlecolorDiff1" : "titlecolorSkill1"}`}>{title}</h5>
            <div className="d-flex gap-2" style={{ marginRight: "45px" }}>
                <div className="progress-bar1" style={{ margin: "0px 20px" }}>
                    <div
                        className="progress1"
                        style={{
                            height: `${progress}%`,
                            background: title === "Difficulty" ? "#83cbeb" : "#84e291",
                            borderRadius: "unset"
                        }}
                    ></div>
                </div>
                <div className={`${title === "Difficulty" ? "progress-labels1" : "progress-labels1-skill"}`}>
                    {levels?.map((level, index) => (
                        <span key={index}>{level}</span>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProgressBar